<script lang="ts" setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { useStore } from '@/store'
import { PmsiTypeEnum, pmsiTypesLabels } from '@/store/modules/settings/types'

const store = useStore()
const { t } = useI18n()

const getCurrentLabel = computed(() => pmsiTypesLabels[store.getters.pmsiType])
</script>

<template>
  <div class="col-1 pe-0">
    <v-dropdown
      id="pmsi-type-selector"
      placement="bottom"
      class="popover-container"
    >
      <button class="btn nav-link dropdown-toggle text-nowrap">
        {{ getCurrentLabel }}
      </button>
      <template #popper>
        <div class="dropdown-menu">
          <router-link
            id="pmsi-type-selector-mco"
            v-close-popper
            class="dropdown-item"
            :active-class="'active'"
            :to="{name: 'home', params: {pmsiType: PmsiTypeEnum.MCO}}"
          >
            {{ t('header.mco') }}
          </router-link>
          <router-link
            id="pmsi-type-selector-smr"
            v-close-popper
            class="dropdown-item"
            :active-class="'active'"
            :to="{name: 'home', params: {pmsiType: PmsiTypeEnum.SMR}}"
          >
            {{ t('header.smr') }}
          </router-link>
        </div>
      </template>
    </v-dropdown>
  </div>
</template>

<style lang="scss" scoped>
@import '@sancare/typescript-commons/src/assets/styles/variables';

.nav-link {
  color: $sancare-header-blue;
  font-weight: 800;
}

.dropdown-menu {
  padding: $space-xs 0 !important;
}
</style>